export const PAYMENT_STEP_INITIAL = 0
export const PAYMENT_STEP_TRANSFER = 1

export const BATCH_PAYMENT_PAY_MATCH = "/payments/new"

export const PAYMENT_SUCCESS_MATCH = "/payment/success"
export const PAYMENT_FAILURE_MATCH = "/payment/failed"

export const MAKSEKESKUS_PAYMENT = "Maksekeskus"

export const SWEDBANK = "Swedbank"
export const LHV = "Lhv"
export const SEB = "Seb"
export const NORDEA = "Nordea"
export const MAKSEKESKUS = "Maksekeskus"
export const PAYSERA = "Paysera"

export const BANKS = [SWEDBANK, LHV, SEB, NORDEA]
export const PAYMENT_GATEWAYS = [MAKSEKESKUS, PAYSERA]
